<template>
  <modal :show="show" @close="close()" id="import-data">
    <div class="modal-head">
      <h3>Import Data</h3>
    </div>

    <div class="modal-content">
      <div class="status">
        <strong>Latest Uploads</strong>
        <p>Google: {{status.google | moment('MMM Do')}}</p>
        <p>Microsoft: {{status.microsoft | moment('MMM Do')}}</p>
        <p>Facebook: {{status.facebook | moment('MMM Do')}}</p>
      </div>
      <form>
        <div class="form-control">
          <label for="import-date">Import Date</label>
          <datepicker id="import-date" v-model="date"></datepicker>
        </div>

        <div class="form-control">
          <input ref="file" @change="assignFile()" type="file" name="file" />
        </div>

        <div class="form-control">
          <fieldset>
            <legend>Data Type</legend>
            <label>
              <input v-model="type" type="radio" name="type" value="google" /> Google Adwords Data
            </label>
            <label>
              <input v-model="type" type="radio" name="type" value="microsoft" /> Microsoft PPC Data
            </label>
            <label>
              <input v-model="type" type="radio" name="type" value="facebook" /> Facebook Advertising Data
            </label>
            <label>
              <input v-model="type" type="radio" name="type" value="call" /> Call Tracking Data
            </label>
          </fieldset>
        </div>

        <button @click.prevent="submitForm" class="button button-blue">Upload</button>
        <button @click.prevent="close()" class="button button-gray">Cancel</button>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/ui/Modal";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "ImportData",
  props: ["show"],
  components: {
    Modal,
    Datepicker
  },
  data() {
    return {
      date: null,
      type: null,
      file: null,
      status: {
        google: null,
        microsoft: null,
        facebook: null
      }
    };
  },
  watch: {
    show: async function() {
      this.$http.get("/lead-tracker/status").then(res => {
        console.log("status", res);
        this.status.google = res.data.google;
        this.status.microsoft = res.data.microsoft;
        this.status.facebook = res.data.facebook;
      });
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getStatus() {
      this.$http.get("/lead-tracker/status").then(res => {
        console.log("status", res);
      });
    },
    assignFile() {
      this.file = this.$refs.file.files[0];
    },
    async submitForm() {
      let formData = new FormData();
      formData.append("date", moment(this.date).format("YYYY-MM-DD"));
      formData.append("type", this.type);
      formData.append("file", this.file);

      let response = await this.$http.post("/lead-tracker/import", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      console.log(response);

      if (!response.data.success) {
        alert(response.data.error);
      } else {
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss">
#import-data {
  .status {
    margin-bottom: 15px;
  }
}
</style>
